export const isSafeLaunchUrl = (value) => {
  if (typeof value !== 'string' || !/^https?:\/\//i.test(value)) return false;
  try {
    const url = new URL(value);
    return Boolean(['http:', 'https:'].includes(url.protocol) && url.hostname && !url.username && !url.password);
  } catch {
    return false;
  }
};

export const getSafeGameReturnPath = (value) => {
  if (typeof value !== 'string' || !value.startsWith('/') || value.includes('\\') || Array.from(value).some(character => character.charCodeAt(0) < 32)) return '/';
  try {
    const url = new URL(value, 'https://game-return.invalid');
    if (url.origin !== 'https://game-return.invalid' || url.pathname === '/play') return '/';
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return '/';
  }
};

export const isSameGameLaunchSnapshot = (expected, current) => Boolean(
  Number.isFinite(expected?.openedAt) && expected.openedAt > 0 && current &&
  ['openedAt', 'playUrl', 'kind', 'gameId', 'lobbyId'].every(key => expected[key] === current[key])
);
